const lessonTariffs = ['hour', 'minute', 'group_per_lesson']

export const usesClassPayment = (order) => order?.class_id != null && Number(order?.class?.one_pay) === 1 && !lessonTariffs.includes(order?.tariff?.type)

export const coursePaymentDate = (order) => {
  if (!usesClassPayment(order)) return order?.next_payment_date
  const users = order?.class?.classUser
  const classUser = (Array.isArray(users) ? users : users ? [users] : []).find((item) => Number(item.user_id) === Number(order?.children_id) && item.deleted_at == null)
  return classUser?.next_payment_date ?? order?.next_payment_date
}
